import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

const links = [
  { id: "szolgaltatasok", label: "Szolgáltatások" },
  { id: "anyagok", label: "Anyagok" },
  { id: "galeria", label: "Munkáink" },
  { id: "ajanlat", label: "Árajánlat" },
  { id: "kapcsolat", label: "Kapcsolat" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="main-nav"
      className={`sticky top-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#F5F2EC]/95 backdrop-blur-md border-b border-[#0A1228]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-3 md:py-4 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
          aria-label="KL Kárpitos főoldal"
        >
          <img
            src={BUSINESS.logoUrl}
            alt="KL Kárpitos logó"
            className="h-12 md:h-14 w-auto transition-transform group-hover:scale-105"
          />
          <div className="hidden sm:block leading-none">
            <div className="font-serif-display text-xl md:text-2xl text-[#0A1228]">
              KL Kárpitos
            </div>
            <div className="text-[9px] md:text-[10px] tracking-[0.35em] uppercase text-[#1E47A8] mt-1">
              Bútorfelújítás
            </div>
          </div>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="relative text-sm text-[#0A1228] hover:text-[#1E47A8] transition-colors tracking-wide group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#1E47A8] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
          <a
            href={`tel:${BUSINESS.phoneTel}`}
            data-testid="nav-call-btn"
            className="flex items-center gap-2 bg-[#1E47A8] text-white px-5 py-2.5 text-xs uppercase tracking-[0.25em] hover:bg-[#16306E] transition-colors"
          >
            <Phone size={14} /> Hívás
          </a>
        </nav>

        <button
          className="md:hidden text-[#0A1228]"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menü"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#F5F2EC] border-t border-[#0A1228]/10">
          <div className="px-6 py-4 flex flex-col gap-2">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-link-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="text-left text-base text-[#0A1228] hover:text-[#1E47A8] py-3 border-b border-[#0A1228]/10"
              >
                {l.label}
              </button>
            ))}
            <a
              href={`tel:${BUSINESS.phoneTel}`}
              className="mt-3 flex items-center justify-center gap-2 bg-[#1E47A8] text-white px-5 py-3 text-xs uppercase tracking-[0.25em]"
            >
              <Phone size={14} /> Hívás most
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
